import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.label<{ $level?: number; $compact?: boolean }>`
  cursor: pointer;

  ${({ theme }) => typographyToCss(theme.typography.body2)};
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme, $level, $compact }) =>
    `${theme.spacing($compact ? 1 : 1.5)} ${theme.spacing(3)}
    ${theme.spacing($compact ? 1 : 1.5)} ${theme.spacing(3 + ($level ?? 0) * 2)}`};
  margin: 0;
  width: 100%;
  min-width: 0;
  max-width: 100%;

  background: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.spacing(2)};
  transition: background 200ms;

  text-align: left;

  -webkit-app-region: no-drag;
`;

export const AffixContainer = styled.span`
  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Content = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  flex: 1;
  min-width: 0;

  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  position: relative;
  width: 59%;
`;

export const Button = styled.button<{
  $isPlaceholder: boolean;
}>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  margin: 0;
  padding: ${({ theme }) =>
    `${theme.spacing(1)} ${theme.spacing(6.5)} ${theme.spacing(1)} ${theme.spacing(2)}`};
  width: 100%;

  cursor: pointer;
  background-color: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  border: ${({ theme }) => `1px solid ${theme.palette.grey[400]}`};
  box-shadow: ${({ theme }) => theme.shadowBox.select};
  overflow: hidden;

  color: inherit;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ $isPlaceholder, theme }) =>
    $isPlaceholder &&
    css`
      color: ${theme.palette.text.secondary};
    `};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: ${({ theme }) =>
        `${theme.spacing(2.5)} ${theme.spacing(8)} ${theme.spacing(2.5)} ${theme.spacing(3)}`};
    `};
`;

export const SelectIconContainer = styled.div`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.spacing(2)};

  transform: translateY(-50%) rotate(-90deg);
  cursor: pointer;

  color: inherit;
  line-height: 62.5%;
  font-size: 1.2rem;
`;

export const PresenceIconSlot = styled.span`
  width: 1.6rem;
  font-size: 1.6rem;
  display: block;
`;

export const ItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => theme.spacing(1)};
`;

export const InputsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Label = styled.label`
  flex: 1;
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  align-self: center;
`;
